import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-713ac5bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-info-circle",
  style: {"font-size":"1.2rem","cursor":"pointer","color":"#0D3D52"}
}, null, -1))
const _hoisted_2 = { class: "agility-rating-tooltip" }
const _hoisted_3 = { class: "tooltip-title" }
const _hoisted_4 = { class: "rating-legend" }
const _hoisted_5 = { class: "rating-details" }
const _hoisted_6 = { class: "rating-range" }
const _hoisted_7 = { class: "rating-description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoTooltip = _resolveComponent("InfoTooltip")!

  return (_openBlock(), _createBlock(_component_InfoTooltip, { position: _ctx.position }, {
    trigger: _withCtx(() => [
      _renderSlot(_ctx.$slots, "trigger", {}, () => [
        _hoisted_1
      ], true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ratingEntries, (rating, key) => {
            return (_openBlock(), _createElementBlock("div", {
              key: key,
              class: "rating-item"
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["rating-color-sample", _ctx.getRatingInfo(rating.min).colors.bg])
              }, null, 2),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("strong", null, _toDisplayString(_ctx.getRatingInfo(rating.min).name), 1),
                  _createTextVNode(" (" + _toDisplayString(rating.min) + "-" + _toDisplayString(rating.max) + ") ", 1)
                ]),
                _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.getRatingInfo(rating.min).description), 1)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _: 3
  }, 8, ["position"]))
}